import { THEMES } from '../constants/theme.constants';

export const DEFAULT_DARK_THEME = THEMES.DARK;
export const DEFAULT_LIGHT_THEME = THEMES.DEFAULT;
